
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoHd9Grid extends Serenity.EntityGrid<PsAdvPromoHd9Row, any> {
        protected getColumnsKey() { return PsAdvPromoHd9Columns.columnsKey; }
        protected getDialogType() { return PsAdvPromoHd9Dialog; }
        protected getIdProperty() { return PsAdvPromoHd9Row.idProperty; }
        protected getInsertPermission() { return PsAdvPromoHd9Row.insertPermission; }
        protected getLocalTextPrefix() { return PsAdvPromoHd9Row.localTextPrefix; }
        protected getService() { return PsAdvPromoHd9Service.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(
                {
                    title: Q.text("Close"), // *** Get button text from translation
                    cssClass: '.panel-titlebar-close',
                    icon: 'fa-close',
                    onClick: () => {
                        window.location.href = '/';
                        return false;
                    },
                }
            );
            return buttons;

        }
    }
}